'use client';

import { c as _c } from "react/compiler-runtime";
import { Minus, Moon, Plus } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import type { ItineraryCardNightStepperProps } from './ItineraryCard.types';
import styles from './ItineraryCardNightStepper.module.css';
export function ItineraryCardNightStepper(t0) {
  const $ = _c(32);
  const {
    nights,
    onDecrement,
    onIncrement,
    readOnly: t1
  } = t0;
  const readOnly = t1 === undefined ? false : t1;
  const t = useTranslations("journey");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className={styles.labelIcon} aria-hidden="true"><Moon size="small" decorative={true} /></span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t) {
    t3 = t("itinerary_night_label");
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className={styles.label}>{t2}<span className={styles.labelText}>{t3}</span></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("itinerary_decrease_nights");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = readOnly || nights <= 1;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Minus size="small" decorative={true} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== onDecrement || $[9] !== t5 || $[10] !== t6) {
    t8 = <span className={styles.stepperButton}><Button variant="neutral" size="extraSmall" aria-label={t5} isDisabled={t6} onPress={onDecrement} dataTestId="night-stepper-decrement">{t7}</Button></span>;
    $[8] = onDecrement;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== nights || $[13] !== t) {
    t9 = t("nights_count", {
      count: nights
    });
    $[12] = nights;
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== nights || $[16] !== t9) {
    t10 = <output className={styles.count} aria-live="polite" aria-label={t9}>{nights}</output>;
    $[15] = nights;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t("itinerary_increase_nights");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Plus size="small" decorative={true} />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== onIncrement || $[22] !== readOnly || $[23] !== t11) {
    t13 = <span className={styles.stepperButton}><Button variant="neutral" size="extraSmall" aria-label={t11} isDisabled={readOnly} onPress={onIncrement} dataTestId="night-stepper-increment">{t12}</Button></span>;
    $[21] = onIncrement;
    $[22] = readOnly;
    $[23] = t11;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t13 || $[27] !== t8) {
    t14 = <div className={styles.controls}>{t8}{t10}{t13}</div>;
    $[25] = t10;
    $[26] = t13;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14 || $[30] !== t4) {
    t15 = <div className={styles.stepper}>{t4}{t14}</div>;
    $[29] = t14;
    $[30] = t4;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}